import {
  GetConfigCollaboratorsResponse,
  UpdateConfigCollaboratorRequest,
} from "../../../types/api/configurations.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const ConfigurationsCollaboratorsService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetConfigCollaboratorsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetConfigCollaboratorsResponse>(
      `v1/config/collaborators?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async update(
    collaboratorId: number,
    body: UpdateConfigCollaboratorRequest,
  ): Promise<void> {
    await httpClient.patch(`v1/config/collaborators/${collaboratorId}`, body);
  },
};

export default ConfigurationsCollaboratorsService;
